import { ScrollArea } from '@/components/ui/scroll-area';
import { DeviceSearch } from './DeviceSearch';
import { DeviceFilters } from './DeviceFilters';
import { DeviceListItem } from './DeviceListItem';
import { useDevices } from '@/hooks/useDevices';
import { useDeviceStore } from '@/stores/useDeviceStore';
import { useMapStore } from '@/stores/useMapStore';
import { Badge } from '@/components/ui/badge';
import { ArrowLeft } from 'lucide-react';

export function DeviceSidebar() {
  const { devices } = useDevices();
  const selectedDeviceId = useDeviceStore((s) => s.selectedDeviceId);
  const selectDevice = useDeviceStore((s) => s.selectDevice);
  const flyTo = useMapStore((s) => s.flyTo);

  const handleDeviceClick = (deviceId: string) => {
    if (selectedDeviceId === deviceId) {
      selectDevice(null);
      return;
    }
    selectDevice(deviceId);
    const device = devices.find((d) => d.id === deviceId);
    if (device?.last_latitude && device?.last_longitude) {
      flyTo(device.last_longitude, device.last_latitude);
    }
  };

  return (
    <div className="flex h-full flex-col">
      <div className="border-b border-gray-200 px-4 py-3">
        {selectedDeviceId ? (
          <button
            className="flex items-center gap-1.5 text-sm font-medium text-brand-purple hover:underline"
            onClick={() => selectDevice(null)}
          >
            <ArrowLeft className="h-4 w-4" />
            All Devices
          </button>
        ) : (
          <div className="flex items-center justify-between">
            <h2 className="text-base font-semibold text-brand-black">Devices</h2>
            <Badge variant="secondary">{devices.length} devices</Badge>
          </div>
        )}
      </div>

      <div className="space-y-2 border-b border-gray-200 px-4 py-3">
        <DeviceSearch />
        <DeviceFilters />
      </div>

      <ScrollArea className="flex-1">
        {devices.map((device) => (
          <DeviceListItem
            key={device.id}
            device={device}
            isSelected={device.id === selectedDeviceId}
            onClick={() => handleDeviceClick(device.id)}
          />
        ))}
        {devices.length === 0 && (
          <p className="px-4 py-8 text-center text-sm text-gray-400">
            No devices found
          </p>
        )}
      </ScrollArea>
    </div>
  );
}
